module.exports = __webpack_public_path__ + "static/media/testimonial-author-image-1.8a257ecc.png";